/**
 * Save to Notion (#40-#47).
 *
 * Every configuring call answers with the full #40 payload, so the Settings tab replaces its cache
 * instead of refetching — the same contract the Scrapers tab uses for #35-#38.
 */

import type {
  NotionDatabasesResponse,
  NotionDatabaseUpdateBody,
  NotionMappingUpdateBody,
  NotionSaveResponse,
  NotionStateResponse,
  NotionTestResponse,
} from '@lw/shared';
import { apiJson } from './client';

export function getNotion(signal?: AbortSignal): Promise<NotionStateResponse> {
  return apiJson<NotionStateResponse>('/notion', { ...(signal ? { signal } : {}) });
}

export function setNotionToken(token: string): Promise<NotionStateResponse> {
  return apiJson<NotionStateResponse>('/notion/token', { method: 'PUT', body: { token } });
}

export function getNotionDatabases(signal?: AbortSignal): Promise<NotionDatabasesResponse> {
  return apiJson<NotionDatabasesResponse>('/notion/databases', { ...(signal ? { signal } : {}) });
}

export function setNotionDatabase(body: NotionDatabaseUpdateBody): Promise<NotionStateResponse> {
  return apiJson<NotionStateResponse>('/notion/database', { method: 'PUT', body });
}

export function refreshNotionSchema(): Promise<NotionStateResponse> {
  return apiJson<NotionStateResponse>('/notion/schema/refresh', { method: 'POST' });
}

export function setNotionMapping(body: NotionMappingUpdateBody): Promise<NotionStateResponse> {
  return apiJson<NotionStateResponse>('/notion/mapping', { method: 'PUT', body });
}

export function testNotion(): Promise<NotionTestResponse> {
  return apiJson<NotionTestResponse>('/notion/test', { method: 'POST' });
}

export function saveToNotion(postId: number): Promise<NotionSaveResponse> {
  return apiJson<NotionSaveResponse>('/notion/save', { method: 'POST', body: { postId } });
}
